import { styled } from '@mui/material';

import { SxProps, Stack } from '@cast/design-system';

import { AddRowButton } from './AddRowButton';
import { RffInputsArray, RffInputsArrayProps } from './RffInputsArray';
import { RffInputsArrayRowState } from './RffInputsArrayContext';
import { WhenMode } from '../WhenMode';

const StyledInputsArray = styled(RffInputsArray, {
  shouldForwardProp: (prop) => prop !== 'showLabels',
})<{ showLabels?: boolean }>(({ showLabels }) => ({
  '& .RffInputsArray-rows': {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    ...(showLabels
      ? undefined
      : {
          '& .RffInputsArray-row': {
            '&:not(:first-of-type)': {
              '& .MuiInputLabel-root, & .downshift-label': {
                display: 'none',
              },
            },
          },
        }),
  },
}));

export type InputsStackProps<Value = any> = RffInputsArrayProps<Value> & {
  withAddRowButton?: boolean;
  addRowButtonTestId?: string;
  addRowButtonText?: string;
  addRowButtonDisabled?: boolean;
  addRowButtonSx?: SxProps;
  showLabels?: boolean;
};

export const InputsStack = <Value = any,>({
  renderInputsRow,
  withAddRowButton = true,
  addRowButtonTestId,
  addRowButtonText,
  addRowButtonDisabled,
  addRowButtonSx,
  showLabels = false,
  footer,
  ...rest
}: InputsStackProps<Value>) => {
  return (
    <StyledInputsArray
      testId="inputs-stack"
      showLabels={showLabels}
      {...rest}
      renderInputsRow={(rowState: RffInputsArrayRowState) => (
        <Stack>{renderInputsRow(rowState)}</Stack>
      )}
      footer={
        <>
          {withAddRowButton && (
            <WhenMode mode={['edit', 'create']}>
              <AddRowButton
                testId={addRowButtonTestId}
                text={addRowButtonText}
                disabled={addRowButtonDisabled}
                sx={addRowButtonSx}
              />
            </WhenMode>
          )}
          {footer}
        </>
      }
    />
  );
};
